import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UILinkComponent } from './ui-link.component';

@NgModule({
  declarations: [
    UILinkComponent
  ],
  exports: [
    UILinkComponent
  ],
  imports: [
    CommonModule
  ]
})
export class UILinkModule { }
